<app-pcbread-crumb [data]="'Reports,FactorReport'"></app-pcbread-crumb>
<app-factor-table [endPoint]="'BuyFactorReport'"></app-factor-table>